<script setup lang="ts">
import { getIconPath } from "@/util/WebRgUtil";
import { MUButton } from "@xlabmedical/medic-web-framework";
import type { MenuItem } from "primevue/menuitem";
import { ref } from "vue";

const emits = defineEmits(["itemClicked"]);

const items = defineModel<MenuItem[]>("items");
const btnClass = defineModel("class");
const disabled = defineModel<boolean>("disabled", { default: false });

const menu = ref();

const toggle = (event: Event) => {
    menu.value.toggle(event);
};
</script>

<template>
    <span aria-haspopup="true" aria-controls="overlay_menu" @click="toggle">
        <MUButton id="btnPatientMore" :class="btnClass" class="web-rg-icon-btn" :iconSrc="'/icons/rg_more_horiz.svg'" :disabled="disabled" data-pc-name="button" />
    </span>
    <Menu ref="menu" id="overlay_menu" :model="items" class="w-full md:w-60" :popup="true">
        <template #start></template>
        <template #submenuitem="{ item }">
            <span class="text-primary font-bold">{{ item.label }}</span>
        </template>
        <template #item="{ item, props }">
            <a class="flex items-center" v-bind="props.action" @click="emits('itemClicked', item.label)">
                <span :class="item.icon" />
                <span :id="`btnPatientMore_${item.label}`">{{ item.label }}</span>
                <Badge v-if="item.badge" class="ml-auto" :value="item.badge" />
                <span v-if="item.shortcut" class="ml-auto border border-surface rounded bg-emphasis text-muted-color text-xs p-1">{{ item.shortcut }}</span>
            </a>
        </template>
        <template #end></template>
    </Menu>
</template>

<style scoped></style>
